// extracted by mini-css-extract-plugin
module.exports = {"item":"IppicaHeaderInfoAccordion_item__4rLYX","withMarginRight":"IppicaHeaderInfoAccordion_withMarginRight__NjSXM"};